import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import appStore from './modules/app';
import customerStore from './modules/customer';
import user from './modules/user';
import buildingStore from './modules/building';
import floorStore from './modules/floor';
import fireProtectionStore from './modules/fireProtection';
import mapStore from './modules/map';
import areaStore from './modules/area';
import mapItemStore from './modules/mapItem';
import fileStore from './modules/file';
import roleStore from './modules/role';
import questionGroupStore from './modules/questionGroup';
import questionListStore from './modules/questionList';
import questionStore from './modules/question';
import roundPlanningStore from './modules/roundPlanning';
import roundStore from './modules/round';
import roundHistoryStore from './modules/roundHistory';
import roundHistoryQuestionStore from './modules/roundHistoryQuestion';
import roundHistoryItemStore from './modules/roundHistoryItem';
import roundHistoryInfoStore from './modules/roundHistoryInfo';
import flawStore from './modules/flaw';
import companyStore from './modules/company';
import apiKeyStore from './modules/apikey';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		appStore,
		customerStore,
		user,
		buildingStore,
		floorStore,
		fireProtectionStore,
		mapStore,
		areaStore,
		mapItemStore,
		fileStore,
		roleStore,
		questionGroupStore,
		questionListStore,
		questionStore,
		roundPlanningStore,
		roundStore,
		roundHistoryStore,
		roundHistoryQuestionStore,
		roundHistoryItemStore,
		roundHistoryInfoStore,
		flawStore,
		companyStore,
		apiKeyStore
	},

	plugins: [
		createPersistedState({
			paths: ['user'],
			key: 'brandexp'
		})
	]
});
